var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17417 0.549181C6.9064 -0.18305 8.09359 -0.18305 8.82582 0.549181C9.55805 1.28141 9.55805 2.4686 8.82582 3.20083C8.09359 3.93306 6.9064 3.93306 6.17417 3.20083C5.44194 2.4686 5.44194 1.28141 6.17417 0.549181Z",
    fill: "#8F90A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17417 6.17418C6.9064 5.44195 8.09359 5.44195 8.82582 6.17418C9.55805 6.90641 9.55805 8.0936 8.82582 8.82583C8.09359 9.55806 6.9064 9.55806 6.17417 8.82583C5.44194 8.0936 5.44194 6.90641 6.17417 6.17418Z",
    fill: "#8F90A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17417 11.7992C6.9064 11.0669 8.09359 11.0669 8.82582 11.7992C9.55805 12.5314 9.55805 13.7186 8.82582 14.4508C8.09359 15.1831 6.9064 15.1831 6.17417 14.4508C5.44194 13.7186 5.44194 12.5314 6.17417 11.7992Z",
    fill: "#8F90A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.87c0125265e312f16d95651d24353a95.svg";
export { ForwardRef as ReactComponent };